import { createSlice } from "@reduxjs/toolkit";
import { getAllInvoice, getInvoicePdf } from "../api/invoice";

interface UsersState {
    loading: boolean;
    currentRequestId: undefined | string;
    userData: any;
    error: any;
}

const initialState = {
    loading: false,
    currentRequestId: undefined,
    userData: null,
    error: null,
} as UsersState;

export const paymentInvoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        resetPaymentInvoice: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(getAllInvoice.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getAllInvoice.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getAllInvoice.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(getInvoicePdf.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getInvoicePdf.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getInvoicePdf.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetPaymentInvoice } = paymentInvoiceSlice.actions;

export default paymentInvoiceSlice.reducer;
